import { browser } from '$app/environment';
import { db } from '$lib/firestore';
import { mapSnapshot } from '$lib/helpers';
import { logError } from '$lib/helpers/errors';
import {
	getDoc,
	doc,
	query,
	collection,
	where,
	orderBy,
	getDocs,
	getCountFromServer
} from 'firebase/firestore';

export async function getPrizeCount() {
	let prizeCount = 0;
	if (!browser || !db) {
		return;
	}
	try {
		const firestore = await db();

		// const docRef = await doc(firestore, "settings", "counts")
		// const docSnap = await getDoc(docRef);

		// if (docSnap.exists()) {
		//     prizeCount = docSnap.data().prize
		// } else {
		// // doc.data() will be undefined in this case
		//     console.log("No such prizeCount!");
		// }

		const coll = collection(firestore, 'products');
		const snapshot = await getCountFromServer(coll);

		prizeCount = snapshot.data().count;

		return prizeCount;
	} catch (error) {
		logError(error, 'firestore:getPrizeCount');
		console.log('getprizeCount error: ', error);
	}
}
